import { store } from '@betacrew/jars-flux';

export const componentKey = "QBD_WEBCONNECTOR_SWITCH";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setIsWebConnectorAuthenticated: (state, action) => {
            state.isWebConnectorAuthenticated = action.payload;
        },
        setImportData: (state, action) => {
            state.importData = action.payload;
        },
        setIsImportDataGridViewLoaded: (state, action) => {
            state.isImportDataGridViewLoaded = action.payload;
        },
        setFormSettings: (state, action) => {
            state.formSettings = action.payload;
        },
        setWebConnectorSyncData: (state, action) => {
            state.webConnectorSyncData = action.payload;
        },
        setIsQbInactiveVendor: (state, action) => {
            state.isQbInactiveVendor = action.payload;
        },
    },
    initialReducerState: {
        loadingState: false,
        isWebConnectorAuthenticated: false,
        importData: null,
        isImportDataGridViewLoaded: false,
        formSettings: null,
        webConnectorSyncData: null,
        isQbInactiveVendor: false
    }
});

export const { setLoadingState, setIsWebConnectorAuthenticated, setImportData, setIsImportDataGridViewLoaded, setFormSettings, setWebConnectorSyncData, setIsQbInactiveVendor } = actions;